import React, { Component, Children } from 'react';
import { Dialog } from '@material-ui/core';
import VMButton from '../VMButton';
import i18n from '../../i18n';
import './TwoBtnDialog.scss';
class TwoBtnDialog extends Component {
    render() {
        const { 
            open, 
            onClose, 
            children, 
            onClick, 
            maxWidth,
            header,
            cancelBtnLabel,
            confirmBtnLabel,
            isFlexConfirmBtn = false
        } = this.props
        return (
            <Dialog open={open} onClose={onClose} maxWidth={maxWidth || "sm"}>
                <div className="TwoBtnDialog-container">
                    <div className={"TwoBtnDialog-container-header"}>
                        {header || i18n.t("global.alert")}
                    </div>
                    <div className="TwoBtnDialog-container-text">{children}</div>
                    <div className="button-group">
                        <VMButton
                            width={"110px"}
                            height={"35px"}
                            style={{ marginRight: "40px", fontSize: "16px", borderRadius: "4px", fontWeight: "600" }}
                            onClick={onClose}>{cancelBtnLabel ? cancelBtnLabel : i18n.t("global.cancel")}</VMButton>
                        <VMButton
                            isFlexBtn={isFlexConfirmBtn}
                            width={"110px"}
                            height={"35px"}
                            color={"dark-gray-v2"}
                            style={{ fontSize: "16px", borderRadius: "4px", fontWeight: "600" }}
                            onClick={onClick}>{confirmBtnLabel ? confirmBtnLabel : i18n.t("global.confirm")}</VMButton>
                    </div>
                </div>
            </Dialog>
        );
    }
}

export default TwoBtnDialog;